export default __webpack_public_path__ + "static/media/Mist.4762d3fd.jpg";